@if (form) {
  <div class="modal-content doc-upload-modal" *let="isDocumentCreating$ | async as creating">
    <div class="modal-header">
      <h5 class="modal-title pull-left">{{ title }}</h5>
      <mat-icon svgIcon="close" (click)="onCancel()" [ngClass]="{ disabled: !!creating }">
      </mat-icon>
    </div>

    <div class="modal-body" [formGroup]="form">
      @if (showFileUploadError) {
        <div class="row">
          <div class="col">
            <app-alert [type]="alertTypes.Error">
              {{ fileUploadErrorMessage }}
            </app-alert>
          </div>
        </div>
      }

      @if (!isFileSelected) {
        <div class="row">
          <div class="col">
            @if (canUploadFiles) {
            <ngx-file-drop
              (onFileDrop)="dropped($event)"
              [multiple]="false"
              accept="{{ constants.fileUploaderAcceptedFormats.join(',') }}"
            >
              <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <mat-icon class="upload-icon" svgIcon="upload_file"></mat-icon>
                <p>
                  {{ 'text.dragAndDrop' | transloco }}
                </p>
                <p>
                  {{ 'text.or' | transloco }}
                </p>
                <p>
                  <button type="button" (click)="openFileSelector()">
                    {{ 'buttons.browse' | transloco }}
                  </button>
                </p>
              </ng-template>
            </ngx-file-drop>
            }
            <span class="supportedFormats">
              {{ 'text.supportedFormats' | transloco }}
            </span>
          </div>
        </div>
      } @else {
        <div class="doc-upload-modal__card">
          <section class="doc-upload-modal__section">
            <div class="doc-upload-modal__section-title">
              {{ 'labels.fileUpload' | transloco }}
            </div>

            <div class="doc-upload-modal__file-row">
              @for (item of files; track item.relativePath) {
                <div class="doc-upload-modal__file-name">
                  {{ item.relativePath }}
                </div>
              }

              @if (creating || isSelectedDocumentFileUploading) {
                <div class="progress-loader non-blocking file-status" [hidden]="false">
                  <div class="spinner-border" role="file-status"></div>
                </div>
              }
            </div>
          </section>

          <section class="doc-upload-modal__section doc-upload-modal__section--spaced">
            <div class="doc-upload-modal__section-title">
              {{ 'titles.documentAttributes' | transloco }}
            </div>

            <div class="doc-upload-modal__attributes-grid">
              <div class="doc-upload-modal__attributes-column">
                <div class="doc-upload-modal__field">
                  <div class="doc-upload-modal__field-label">
                    {{ 'labels.docName' | transloco }}
                  </div>
                  <app-input
                    placeholder="{{ 'labels.docName' | transloco }}"
                    formControlName="documentName"
                  ></app-input>
                </div>
              </div>

              <div class="doc-upload-modal__attributes-column">
                <div class="doc-upload-modal__field">
                  <div class="doc-upload-modal__field-label">
                    {{ 'labels.docLanguage' | transloco }}
                  </div>
                  <app-single-select-autocomplete
                    class="w100"
                    formControlName="languageId"
                    [autocompleteOptions]="contentLanguages"
                    optionLabel="displayName"
                  ></app-single-select-autocomplete>
                </div>
              </div>

              <div class="doc-upload-modal__attributes-column">
                <div class="doc-upload-modal__field">
                  <div class="doc-upload-modal__field-label">
                    {{ 'labels.docType' | transloco }}
                  </div>
                  <app-single-select-autocomplete
                    class="w100"
                    formControlName="documentType"
                    [autocompleteOptions]="docTypeItems"
                  ></app-single-select-autocomplete>

                  @if (canCreateNewDocType) {
                    <button
                      type="button"
                      class="doc-upload-modal__text-link"
                      [disabled]="!!creating"
                      (click)="openNewDocTypeForm()"
                    >
                      <span class="doc-upload-modal__text-link-prefix">
                        <mat-icon svgIcon="add"></mat-icon>
                      </span>
                      <span class="doc-upload-modal__text-link-label">
                        {{ 'buttons.createNewType' | transloco }}
                      </span>
                    </button>
                  }
                </div>

                @if (creatingNewDocType && addDocTypeForm) {
                  <div class="doc-upload-modal__inline-create">
                    <div class="arrow-up"></div>
                    <div class="new-item-form" [formGroup]="addDocTypeForm">
                      <div class="doc-upload-modal__inline-create-text">
                        {{ 'text.createNewDocType' | transloco }}
                      </div>

                      <div class="doc-upload-modal__inline-create-control">
                        <app-input
                          label="{{ 'labels.docType' | transloco }}"
                          placeholder="{{ 'labels.docType' | transloco }}"
                          formControlName="newDocumentType"
                          [id]="'newDocumentType'"
                        ></app-input>
                      </div>

                      <div class="new-item-form__footer">
                        <app-button
                          [type]="btnTypes.Flat"
                          label="{{ 'buttons.add' | transloco }}"
                          [disabled]="addDocTypeForm.invalid"
                          [size]="btnSizes.Basic"
                          (onClick)="onConfirmNewDocType()"
                        ></app-button>
                        <app-button
                          [type]="btnTypes.Stroked"
                          label="{{ 'buttons.cancel' | transloco }}"
                          [size]="btnSizes.Basic"
                          (onClick)="onCancelNewDocType()"
                        ></app-button>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <div class="doc-upload-modal__attributes-column">
                <div class="doc-upload-modal__field">
                  <div class="doc-upload-modal__field-label">
                    {{ 'labels.counterparties' | transloco }}
                  </div>
                  <app-multi-select-autocomplete
                    class="w100"
                    formControlName="counterparties"
                    [autocompleteOptions]="conterPartyItems"
                    [hiddenOptions]="hiddenConterPartyItems"
                  ></app-multi-select-autocomplete>

                  <button
                    *ngIf="canWrite"
                    type="button"
                    class="doc-upload-modal__text-link"
                    [disabled]="!!creating || !canCreateNewCounterparty"
                    (click)="openNewPartyForm()"
                  >
                    <span class="doc-upload-modal__text-link-prefix">
                      <mat-icon svgIcon="add"></mat-icon>
                    </span>
                    <span class="doc-upload-modal__text-link-label">
                      {{ 'buttons.createNewCounterparty' | transloco }}
                    </span>
                  </button>
                </div>

                @if (creatingNewParty && addPartyForm) {
                  <div class="doc-upload-modal__inline-create">
                    <div class="arrow-up"></div>
                    <div class="new-item-form" [formGroup]="addPartyForm">
                      <div class="doc-upload-modal__inline-create-text">
                        {{ 'text.createNewParty' | transloco }}
                      </div>

                      <div class="doc-upload-modal__inline-create-control">
                        <app-input
                          label="{{ 'labels.counterparty' | transloco }}"
                          placeholder="{{ 'labels.counterparty' | transloco }}"
                          formControlName="newPartyName"
                          [id]="'newPartyName'"
                        ></app-input>
                      </div>

                      <div class="new-item-form__footer">
                        <app-button
                          [type]="btnTypes.Flat"
                          label="{{ 'buttons.add' | transloco }}"
                          [disabled]="addPartyForm.invalid"
                          [size]="btnSizes.Basic"
                          (onClick)="onConfirmNewParty()"
                        ></app-button>
                        <app-button
                          [type]="btnTypes.Stroked"
                          label="{{ 'buttons.cancel' | transloco }}"
                          [size]="btnSizes.Basic"
                          (onClick)="onCancelNewParty()"
                        ></app-button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </section>

          <section class="doc-upload-modal__section doc-upload-modal__section--spaced">
            <div
              class="doc-upload-modal__section-title doc-upload-modal__section-title--with-tooltip"
            >
              <span>{{ 'titles.workflowContext' | transloco }}</span>
              <app-tooltip [text]="'tooltip.workflowContext' | transloco" class="inline-tooltip">
              </app-tooltip>
            </div>

            <div class="doc-upload-modal__field">
              <div class="doc-upload-modal__field-label">
                {{ 'labels.myPosition' | transloco }}
              </div>
              <app-radio formControlName="myPosition" [items]="positionItems"></app-radio>
            </div>

            <div class="doc-upload-modal__field doc-upload-modal__field--playbook">
              <div class="doc-upload-modal__playbook-toggle-row">
                <div class="doc-upload-modal__playbook-toggle-group">
                  <div class="doc-upload-modal__field-label">
                    {{ 'titles.playbook' | transloco }}
                  </div>

                  <label class="doc-upload-modal__switch" for="playbookEnabled">
                    <input
                      id="playbookEnabled"
                      type="checkbox"
                      class="doc-upload-modal__switch-input"
                      formControlName="playbookEnabled"
                    />
                    <span class="doc-upload-modal__switch-slider"></span>
                  </label>
                </div>

                <button
                  *ngIf="canWrite"
                  type="button"
                  class="doc-upload-modal__text-link doc-upload-modal__text-link--external"
                  (click)="openCreatePlaybookPage()"
                >
                  <span class="doc-upload-modal__text-link-prefix">
                    <mat-icon svgIcon="add"></mat-icon>
                  </span>
                  <span class="doc-upload-modal__text-link-label">
                    {{ 'buttons.createPlaybook' | transloco }}
                  </span>
                  <mat-icon class="doc-upload-modal__external-icon">open_in_new</mat-icon>
                </button>
              </div>

              @if (showPlaybookOptionalInfo) {
                <div class="doc-upload-modal__playbook-info">
                  {{ 'text.playbookOptionalInfo' | transloco }}
                </div>
              }

              @if (isPlaybookEnabled) {
                @if (hasAvailablePlaybooks) {
                  <div class="doc-upload-modal__playbook-search">
                    <app-search-input
                      formControlName="playbookSearch"
                      placeholder="{{ 'placeholders.filterPlaybooks' | transloco }}"
                    ></app-search-input>
                  </div>

                  @if (showNoFilteredPlaybooksState) {
                    <div class="doc-upload-modal__playbook-results-empty">
                      {{ 'text.noPlaybooksMatchFilters' | transloco }}
                    </div>
                  } @else {
                    @if (showSuggestedPlaybooksSection) {
                      <div class="doc-upload-modal__playbook-table-card">
                        <div class="doc-upload-modal__playbook-table-heading">
                          {{ 'titles.suggestedPlaybooks' | transloco }}
                        </div>

                        @if (visibleSuggestedPlaybooks.length) {
                          <table class="doc-upload-modal__playbook-table">
                            <tbody>
                              @for (
                                playbook of visibleSuggestedPlaybooks;
                                track playbook.uniqueId
                              ) {
                                <tr
                                  class="doc-upload-modal__playbook-row"
                                  [ngClass]="{
                                    'doc-upload-modal__playbook-row--selected': isPlaybookSelected(
                                      playbook.uniqueId
                                    )
                                  }"
                                  (click)="togglePlaybookSelection(playbook.uniqueId)"
                                >
                                  <td class="doc-upload-modal__playbook-display-name">
                                    {{ playbook.displayName }}
                                  </td>
                                  <td class="doc-upload-modal__playbook-action">
                                    <button
                                      type="button"
                                      class="doc-upload-modal__playbook-select"
                                      (click)="
                                        togglePlaybookSelection(playbook.uniqueId);
                                        $event.stopPropagation()
                                      "
                                    >
                                      <span class="doc-upload-modal__playbook-select-indicator">
                                        @if (isPlaybookSelected(playbook.uniqueId)) {
                                          <mat-icon>check</mat-icon>
                                        }
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        } @else if (showSuggestedPlaybooksEmptyState) {
                          <div class="doc-upload-modal__playbook-empty-state">
                            <div class="doc-upload-modal__playbook-empty-heading">
                              <mat-icon
                                class="doc-upload-modal__playbook-empty-icon"
                                svgIcon="warning"
                              ></mat-icon>
                              <div class="doc-upload-modal__playbook-empty-title">
                                {{ 'text.noMatchingPlaybookFoundTitle' | transloco }}
                              </div>
                            </div>
                            <div class="doc-upload-modal__playbook-empty-text">
                              {{ 'text.noMatchingPlaybookFoundDescriptionStart' | transloco }}
                              <button
                                *ngIf="canWrite"
                                type="button"
                                class="doc-upload-modal__text-link doc-upload-modal__text-link--inline doc-upload-modal__text-link--external"
                                (click)="openCreatePlaybookPage()"
                              >
                                <span class="doc-upload-modal__text-link-label">
                                  {{ 'text.createNewPlaybookInline' | transloco }}
                                </span>
                                <mat-icon class="doc-upload-modal__external-icon"
                                  >open_in_new</mat-icon
                                >
                              </button>
                              {{ 'text.noMatchingPlaybookFoundDescriptionEnd' | transloco }}
                            </div>
                          </div>
                        }
                      </div>
                    }

                    @if (showAllPlaybooksSection) {
                      <div class="doc-upload-modal__playbook-table-card">
                        <div class="doc-upload-modal__playbook-table-heading">
                          {{ 'titles.allPlaybooks' | transloco }}
                        </div>

                        <table class="doc-upload-modal__playbook-table">
                          <tbody>
                            @for (playbook of visibleAllPlaybooks; track playbook.uniqueId) {
                              <tr
                                class="doc-upload-modal__playbook-row"
                                [ngClass]="{
                                  'doc-upload-modal__playbook-row--selected': isPlaybookSelected(
                                    playbook.uniqueId
                                  )
                                }"
                                (click)="togglePlaybookSelection(playbook.uniqueId)"
                              >
                                <td class="doc-upload-modal__playbook-display-name">
                                  {{ playbook.displayName }}
                                </td>
                                <td class="doc-upload-modal__playbook-action">
                                  <button
                                    *ngIf="canWrite"
                                    type="button"
                                    class="doc-upload-modal__playbook-select"
                                    (click)="
                                      togglePlaybookSelection(playbook.uniqueId);
                                      $event.stopPropagation()
                                    "
                                  >
                                    <span class="doc-upload-modal__playbook-select-indicator">
                                      @if (isPlaybookSelected(playbook.uniqueId)) {
                                        <mat-icon>check</mat-icon>
                                      }
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                  }

                  @if (showExpandAllPlaybooksLink) {
                    <button
                                *ngIf="canWrite"
                      type="button"
                      class="doc-upload-modal__text-link doc-upload-modal__text-link--see-all"
                      (click)="revealAllPlaybooks()"
                    >
                      <mat-icon class="doc-upload-modal__toggle-link-icon">expand_more</mat-icon>
                      <span class="doc-upload-modal__text-link-label">
                        {{ 'buttons.seeAllPlaybooks' | transloco: { count: playbookItems.length } }}
                      </span>
                    </button>
                  }

                  @if (showCollapseSuggestedPlaybooksLink) {
                    <button
                      *ngIf="canWrite"
                      type="button"
                      class="doc-upload-modal__text-link doc-upload-modal__text-link--see-all"
                      (click)="collapseToSuggestedPlaybooks()"
                    >
                      <mat-icon class="doc-upload-modal__toggle-link-icon">expand_less</mat-icon>
                      <span class="doc-upload-modal__text-link-label">
                        {{ 'buttons.showSuggestedPlaybooksOnly' | transloco }}
                      </span>
                    </button>
                  }
                } @else {
                  <div class="doc-upload-modal__playbook-empty-state">
                    <div class="doc-upload-modal__playbook-empty-title">
                      {{ 'text.noPlaybookFoundTitle' | transloco }}
                    </div>
                    <div class="doc-upload-modal__playbook-empty-text">
                      {{ 'text.noPlaybookFoundDescription' | transloco }}
                    </div>
                    <button
                      type="button"
                      class="doc-upload-modal__text-link doc-upload-modal__text-link--external"
                      (click)="openCreatePlaybookPage()"
                    >
                      <span class="doc-upload-modal__text-link-prefix">
                        <mat-icon svgIcon="add"></mat-icon>
                      </span>
                      <span class="doc-upload-modal__text-link-label">
                        {{ 'buttons.createPlaybook' | transloco }}
                      </span>
                      <mat-icon class="doc-upload-modal__external-icon">open_in_new</mat-icon>
                    </button>
                  </div>
                }
              }
            </div>
          </section>
        </div>
      }
    </div>

    <div class="modal-footer">
      <app-button
        *ngIf="canWrite"
        [type]="btnTypes.Flat"
        label="{{ 'buttons.add' | transloco }}"
        [disabled]="isSubmitDisabled || !!creating"
        [size]="btnSizes.Basic"
        (onClick)="onConfirm()"
      ></app-button>
      <app-button
        [type]="btnTypes.Stroked"
        label="{{ 'buttons.cancel' | transloco }}"
        [disabled]="!!creating"
        [size]="btnSizes.Basic"
        (onClick)="onCancel()"
      ></app-button>
    </div>
  </div>
}
